import {API_URL,Accept} from '../constants.js';
import {notify} from 'react-notify-toast';
import api from "./api.js";
export default function callSetDeliveredOrder(component,trip_id,order_id,data){
  const rider_id=localStorage.getItem('rider_id');
  const Authorization='bearer '+localStorage.getItem('token');
  fetch(`${API_URL}triporderdeliver`,{
    method:'POST',
    headers:{"Content-Type": "application/json",Accept,Authorization},
        body:JSON.stringify({rider_id,trip_id,order_id,data})
        }).then(function(response){
          if(!response.ok){
              notify.show('Network Failure','error');
          }
            return response.json();
        })
        .then(function(data) {
            if(data[0]&&data[0].status==='success'){
                component.props.actionDeliverySuccessDetails(data[0].data)
                api.callShippingJobs(component,trip_id);
                let localData=JSON.parse(localStorage.getItem('orderData'));
                localData['deliverysuccess']={};
                localData.deliverysuccess=data[0].data;
                localStorage.setItem('orderData',JSON.stringify(localData));
            }


        })
}



// WEBPACK FOOTER //
// ./src/utility/api/callSetDeliveredOrder.js